import { createBeforeSend } from './beforeSend';
export const createSentryOptions = () => {
    return {
        release: `${process.env.ARTIFACT_ID}@${process.env.ARTIFACT_VERSION}`,
        beforeSend: createBeforeSend(),
    };
};
//# sourceMappingURL=createSentryOptions.js.map